import React, { useState } from 'react';
import DataTable from 'react-data-table-component';
import 'bootstrap/dist/css/bootstrap.min.css';

const StaticDataTable = ({ columns =[], data=[], title = 'Table View' }) => {
  const [filterText, setFilterText] = useState('');

  const filteredData = data.filter(row =>
    Object.values(row).some(
      val =>
        val &&
        val.toString().toLowerCase().includes(filterText.toLowerCase())
    )
  );

  return (
    <div className="card shadow-sm mb-4">
      {title && (
        <div className="card-header text-white d-flex align-items-center">
          <h5 className="mb-0">{title}</h5>
        </div>
      )}

      <div className="card-body">
        <div className="mb-3 d-flex justify-content-end">
          <input
            type="text"
            className="form-control w-auto"
            placeholder="Search..."
            value={filterText}
            onChange={(e) => setFilterText(e.target.value)}
          />
        </div>

        <DataTable
          columns={columns}
          data={filteredData}
          pagination
          responsive
          striped
          highlightOnHover
          persistTableHead
          paginationRowsPerPageOptions={[5, 10, 20, 50, 100]}
          noDataComponent="No matching records found"
        />
      </div>
    </div>
  );
};

export default StaticDataTable;